import { render, staticRenderFns } from "./MiniStatistic.vue?vue&type=template&id=77e96bf4&"
import script from "./MiniStatistic.vue?vue&type=script&lang=js&"
export * from "./MiniStatistic.vue?vue&type=script&lang=js&"
import style0 from "./MiniStatistic.vue?vue&type=style&index=0&id=77e96bf4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports